import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SearchFieldSelect } from "../../../components/textfield";
import "../../../assets/styles/admin/so.scss";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Checkbox,
  Form,
  Space,
  Radio,
  Typography,
  message,
} from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import moment from "moment";
import { numberWithCommas } from "../../../helpers/functions";

interface ParamsType {
  id: string;
  idmember: string;
}

const SoDetail = () => {
  const { id, idmember } = useParams<ParamsType>();
  const { Text } = Typography;
  const { Option } = Select;

  let [form] = Form.useForm();
  const [couserat1, setCouserat1] = useState<any>([]);
  const [couserat2, setCouserat2] = useState<any>([]);
  const [couserat3, setCouserat3] = useState<any>([]);
  const [couserat4, setCouserat4] = useState<any>([]);
  const [consult, setConSult] = useState<any>([]);
  const [consult2, setConSult2] = useState<any>([]);
  const [updateConsult, setUpdateConsult] = useState<any>([]);
  const [_xid, setxId] = useState<any>("");
  const [typeSaleCheck, setTypeSaleCheck] = useState<string>("");

  const history = useHistory();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [value, setValue] = useState<any>("local_price");
  const dateFormat2 = "YYYY-MM-DD";
  const dateFormat1 = "DD-MM-YYYY";

  const [allUser, setAllUser] = useState<any>([]);
  const [disabledCouser, setdisabledCouser] = useState<any>([]);
  const [dataTable, setDataTable] = useState<any>([]);
  const [typeSale, setTypeSale] = useState<string>("");
  const [doctor, setDocTor] = useState<any>([]);
  const [historyData, sethistoryData] = useState<any>([]);

  const [soHead, setSoHead] = useState<string>("");

  const columns = [
    {
      key: 1,
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
      width: "20%",
      // render: (text: any, record: any) => {
      //   return <>{text}</>;
      // },
    },
    {
      key: 2,
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
      width: "25%",
    },
    {
      key: 3,
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      key: 4,
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "10%",
      // render: (text: any, record: any, index: number) => (
      //   <div style={{ display: "flex", justifyContent: "center" }}>{text}</div>
      // ),
    },
    {
      title: "รวม/Total",
      dataIndex: "total",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      title: "จำนวน/คอร์ส/Number/Course",
      dataIndex: "number",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text)}</>;
      },
    },
    {
      key: 5,
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "6%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "5%",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
      ],
    },
    {
      key: 6,
      title: "ฟรี/Free",
      dataIndex: "free",
      align: "center" as const,
      width: "28%",
      render: (text: any, record: any, index: number) => {
        return record?.free?.productFree !== undefined &&
          record?.free?.productFree !== null
          ? record?.free?.productFree?.name
          : "Not Select";
      },
    },
    {
      key: 6,
      title: "รหัสฟรี/Code Free",
      dataIndex: "codefree",
      align: "center" as const,
      width: "28%",
      render: (text: any, record: any, index: number) => {
        return record?.free?.codefree;
      },
    },

    {
      key: 7,
      title: "ส่วนลดพิเศษ/Special Discount",
      dataIndex: "specialPrice",
      width: "10%",
      align: "center" as const,
      render(text: any, record: any) {
        return numberWithCommas(text, 2);
      },
    },
    {
      key: 8,
      title: "ราคาพิเศษ/Special Price",
      dataIndex: "specialDiscount",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return numberWithCommas(text, 2);
      },
    },
    {
      key: 9,
      title: "ราคารวม/Total Price",
      dataIndex: "totalPrice",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: number) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },

    {
      key: 10,
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,
      // render: (text: any, record: any, index: number) => {
      //   // console.log("record =>remark", record);
      //   // return <Row style={{ width: "150px" }}>{text}</Row>;
      // },
    },
  ];
  const columnspromo = [
    {
      key: 1,
      title: "รหัส/Code",
      dataIndex: "code",
      align: "center" as const,
      width: "200px",
      // render: (text: any, record: any) => {
      //   return <>{text}</>;
      // },
    },
    {
      key: 2,
      title: "รายการ/List",
      dataIndex: "name",
      align: "center" as const,
      width: "450px",
    },
    {
      key: 3,
      title: "ราคา/หน่วย/Price/Unit",
      dataIndex: "price",
      align: "center" as const,
      width: "200px",
      render: (text: any, record: any) => {
        return <>{numberWithCommas(text, 2)}</>;
      },
    },
    {
      key: 4,
      title: "จำนวน/Quantity",
      dataIndex: "quantity",
      align: "center" as const,
      width: "180px",
      // render: (text: any, record: any, index: number) => (
      //   <div style={{ display: "flex", justifyContent: "center" }}>{text}</div>
      // ),
    },
    // {
    //   title: "รวม/Total",
    //   dataIndex: "total",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{numberWithCommas(text, 2)}</>;
    //   },
    // },

    {
      key: 5,
      title: "คอมมิชชั่น/Commission",
      align: "center" as const,
      children: [
        {
          title: "พนักงานขาย/Sales",
          dataIndex: "isCommissionSales",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
        {
          title: "แพทย์/Doctor",
          dataIndex: "isCommissionDoctor",
          width: "150px",
          align: "center" as const,
          render: (text: any, record: any) => {
            return <>{text === true ? "ได้" : "ไม่ได้"}</>;
          },
        },
      ],
    },

    // {
    //   key: 9,
    //   title: "ราคารวม/Total Price",
    //   dataIndex: "totalPrice",
    //   align: "center" as const,
    //   width: "10%",
    //   render: (text: any, record: any, index: number) => {
    //     return <>{numberWithCommas(text, 2)}</>;
    //   },
    // },

    {
      key: 10,
      title: "ความเห็น/Remark",
      dataIndex: "remark",
      align: "center" as const,
      width: "15%",
      // render: (text: any, record: any, index: number) => {
      //   // console.log("record =>remark", record);
      //   // return <Row style={{ width: "150px" }}>{text}</Row>;
      // },
    },
  ];
  const getAPIs = () => {
    // setCustomer("Ms. A");
    // setChannel("EK-CNF60100015");
    // setMobile("086-4204589");
    // setDate("2564-01-18");
    getDatasHead();
    getUser();
    getUser2();
    getUser3();
    getUser4();
  };

  const getDatasHead = () => {
    console.log("memberID", idmember);

    axios.get(`/so/get-so?soId=${idmember}`).then((res) => {
      let datas = res?.data;
      console.log("datas =>>>", datas);
      setTypeSale(datas?.purchaseType);
      setSoHead(datas?.code);
      form.setFieldsValue({
        customer: datas?.customer,
        cn: datas?.customerCode,
        ref: datas?.code,
        date: datas?.date !== undefined ? moment(datas?.date) : "",
        Couser1: datas?.coMembers[0],
        Couser2: datas?.coMembers[1],
        Couser3: datas?.coMembers[2],
        Couser4: datas?.coMembers[3],
        consult1: datas?.consults[0],
        consult2: datas?.consults[1],
        doctor: datas?.doctor,
        purchaseType: datas?.purchaseType,
        priceType: datas?.priceType,
      });

      getConsult(datas?.consults[0], datas?.consults[1]);
      getDoctor(datas?.doctor);
      setTypePrice(datas);
      getBranch(datas?.branch);
      sethistoryData(datas);
    });
    setdisabledCouser({
      CoUser2: true,
      CoUser3: true,
      CoUser4: true,
    });
  };

  const getDataTableCart = (datas: any, typecode?: string) => {
    console.log("datas table", datas);
    setTypeSaleCheck(datas?.purchaseType);
    if (datas?.purchaseType === "normal") {
      console.log("data normal", datas?.items);
      const newdatacart = datas.items.map((data: any) => ({
        ...data,
        total:
          typecode === "Local"
            ? parseInt(data?.price) * parseInt(data?.quantity)
            : parseInt(data?.priceAgency) * parseInt(data?.quantity),
        number: parseFloat(data?.number) * parseFloat(data?.quantity),
      }));

      setDataTable(newdatacart);
    } else if (datas?.purchaseType === "promotion") {
      // setDataCart()
      console.log("data promotion", value?.items);
      setDataTable(datas?.items);
    }
    // setDataTable(datas);
  };

  const onSubmit = async (values: any) => {
    console.log("values v2 =>", values);
    console.log("history data", historyData);
    // let xdata = {..values};

    let coUsers = [];

    if (values.Couser1) {
      coUsers.push(values.Couser1);
    }

    if (values.Couser2) {
      coUsers.push(values.Couser2);
    }

    if (values.Couser3) {
      coUsers.push(values.Couser3);
    }
    if (values.Couser4) {
      coUsers.push(values.Couser4);
    }

    console.log("coUsers", coUsers);

    // let coConsult = [];

    // if (values.consult1) {
    //   coConsult.push(values.consult1);
    // }

    // if (values.consult1) {
    //   coConsult.push(values.consult1);
    // }

    // console.log("coConsult", coConsult);

    // const \newDatas = xdata.map((data: any) => ({
    //   ...data,
    //
    // }));

    try {
      await axios
        .patch(`/so/edit-so?soId=${idmember}`, {
          branch: historyData?.branch,
          date: moment(values?.date).format(dateFormat2),
          coMembers: coUsers,
          consults: historyData?.consults,
          doctor: historyData?.doctor,
          priceType: historyData?.priceType,
          purchaseType: historyData?.purchaseType,
        })
        .then((res) => {
          console.log("res", res?.data);

          setIsDisabled(false);

          message.success("บันทึกสำเร็จ");
          history.push(`/opd/so/${id}`);
        });
    } catch (error) {
      message.error("ผิดพลาด");

      return;
    }
  };
  const getBranch = (id: any) => {
    axios.get(`/branches/${id}`).then((res) => {
      form.setFieldsValue({ branch: res?.data?.data?.name });
    });
  };
  const getUser = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;
        console.log("res", res?.data?.data);
        const xUser = [];

        let x = {
          code: "ไม่ระบุ/Not Specified",
          _id: "",
          name: "ไม่ระบุ/Not Specified",
        };

        datas.push(x);

        for (let i = 0; i < datas?.length; i++) {
          xUser.push(
            <Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Option>
          );
        }

        setCouserat1(xUser);
      });
  };

  const getUser2 = async (iduser1?: any) => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        //  console.log("data select", data);
        const user1 = form.getFieldsValue(["Couser1"]);
        // getUser2(data);
        console.log("res user 2", user1.Couser1);
        let datas = res?.data?.data;
        console.log("datas user2 before", datas);

        let x = datas.filter((data: any) => data._id !== user1.Couser1);

        console.log("datas user2", datas);

        const xUser = [];
        let xoptfrees = {
          code: "ไม่ระบุ/Not Specified",
          id: "",
          name: "ไม่ระบุ/Not Specified",
        };
        x.push(xoptfrees);
        for (let i = 0; i < x?.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }
        setCouserat2(xUser);
      });
  };

  const getUser3 = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;

        console.log("datas user 3 ", datas);

        const user2 = form.getFieldsValue(["Couser1", "Couser2"]);

        const x = datas.filter(
          (data: any) =>
            data?._id !== user2?.Couser1 && data?._id !== user2?.Couser2
        );
        console.log("x =>>>", x);

        // console.log("res", res?.data?.data);
        const xUser = [];
        let xoptfrees = {
          code: "ไม่ระบุ/Not Specified",
          id: "",
          name: "ไม่ระบุ/Not Specified",
        };
        x.push(xoptfrees);
        for (let i = 0; i < x.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }

        setCouserat3(xUser);
      });
  };
  const getUser4 = async () => {
    await axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        let datas = res?.data?.data;
        const user3 = form.getFieldsValue(["Couser1", "Couser2", "Couser3"]);

        const x = datas.filter(
          (data: any) =>
            data?._id !== user3?.Couser1 &&
            data?._id !== user3?.Couser2 &&
            data?._id !== user3?.Couser3
        );
        console.log("x =>>>", x);

        // console.log("res", res?.data?.data);
        const xUser = [];
        let xoptfrees = {
          code: "ไม่ระบุ/Not Specified",
          id: "",
          name: "ไม่ระบุ/Not Specified",
        };
        x.push(xoptfrees);

        for (let i = 0; i < x.length; i++) {
          xUser.push(
            <Option value={x[i]?._id} key={x[i]?._id}>
              {x[i]?.name}
            </Option>
          );
        }

        setCouserat4(xUser);
      });
  };
  const onchangeUser1 = (data: any, type: string) => {
    getUser2();
  };
  const onchangeUser2 = (data: any, type: string) => {
    getUser3();
  };
  const onchangeUser3 = (data: any, type: string) => {
    getUser4();
  };
  const onchangeUser4 = (data: any, type: string) => {};
  const getConsult = async (_id1: string, _id2: string) => {
    axios.get(`/users/${_id1}`).then((res) => {
      const datas = res?.data?.displayName;
      form.setFieldsValue({
        consult1: datas,
      });
    });

    axios.get(`/users/${_id2}`).then((res) => {
      const datas = res?.data?.displayName;
      form.setFieldsValue({
        consult2: datas,
      });
    });
  };

  const getDoctor = async (_id: string) => {
    // const dataDoc = await axios.get(`/users?page=1&branch=all&search=`);
    // const xDoctor = [];
    // const Doctor = dataDoc?.data?.data.filter(
    //   (datares: any) => datares?.permission?.name === "CS"
    // );

    axios.get(`/users/${_id}`).then((res) => {
      const datas = res?.data?.displayName;
      form.setFieldsValue({
        doctor: datas,
      });
    });

    // let xoptfrees = {
    //   code: "ไม่ระบุ/Not Specified",
    //   id: "",
    //   name: "ไม่ระบุ/Not Specified",
    // };
    // Doctor.push(xoptfrees);
    // console.log("Doctor =>>>>", Doctor);

    // for (let i = 0; i < Doctor?.length; i++) {
    //   xDoctor.push(
    //     <Option value={Doctor[i]?._id} key={Doctor[i]?._id}>
    //       {Doctor[i]?.displayName}
    //     </Option>
    //   );
    // }
    // setDocTor(xDoctor);
    // const doc = dataDoc.find((x: any) => x.value === subCityId);
  };
  // const onchangeUser1 = (data: any, type: string) => {
  //   setAllUser(null);

  //   console.log("couserat1", couserat1);

  //   const xuser2 = couserat1.filter(
  //     (e: any) => e?.props?.value !== data
  //     // console.log("e=>>>>>>>", e);
  //   );

  //   console.log("xuser2", xuser2);

  //   const xcouserat2 = [];

  //   for (let i = 0; i < xuser2?.length; i++) {
  //     xcouserat2.push(
  //       <Option value={xuser2[i]?.props?.value} key={xuser2[i]?.props?.value}>
  //         {xuser2[i]?.props?.children}
  //       </Option>
  //     );
  //   }
  //   console.log("xcouserat2", xcouserat2);
  //   setCouserat2(xcouserat2);

  //   setAllUser([...allUser, data]);
  //   updateUser("couserat1", data);
  // };
  // const onchangeUser2 = (data: any, type: string) => {
  //   console.log("couserat2", couserat2);

  //   const xuser2 = couserat2.filter(
  //     (e: any) => e?.props?.value !== data
  //     // console.log("e=>>>>>>>", e);
  //   );

  //   console.log("xuser2", xuser2);

  //   const xcouserat3 = [];

  //   for (let i = 0; i < xuser2?.length; i++) {
  //     xcouserat3.push(
  //       <Option value={xuser2[i]?.props?.value} key={xuser2[i]?.props?.value}>
  //         {xuser2[i]?.props?.children}
  //       </Option>
  //     );
  //   }
  //   console.log("xcouserat3", xcouserat3);

  //   setCouserat3(xcouserat3);

  //   updateUser("couserat2", data);

  //   setAllUser([...allUser, data]);
  // };
  // const onchangeUser3 = (data: any, type: string) => {
  //   console.log("couserat3", couserat3);

  //   const xuser3 = couserat3.filter(
  //     (e: any) => e?.props?.value !== data
  //     // console.log("e=>>>>>>>", e);
  //   );

  //   console.log("xuser2", xuser3);

  //   const xcouserat4 = [];

  //   for (let i = 0; i < xuser3?.length; i++) {
  //     xcouserat4.push(
  //       <Option value={xuser3[i]?.props?.value} key={xuser3[i]?.props?.value}>
  //         {xuser3[i]?.props?.children}
  //       </Option>
  //     );
  //   }
  //   console.log("xcouserat4", xcouserat4);

  //   setCouserat4(xcouserat4);
  //   updateUser("couserat3", data);
  // };
  // const onchangeUser4 = (data: any, type: string) => {
  //   updateUser("couserat4", data);
  // };
  // const updateUser = (type: any, value: any) => {
  //   // console.log("updateUser", type + "    " + value);
  //   // axios
  //   //   .patch(`/so/${_xid}`, {
  //   //     coMembers: [value],
  //   //   })
  //   //   .then((res) => {
  //   //     console.log("res updateuser", res?.data);
  //   //   });
  // };

  const setTypePrice = (xdata: any) => {
    console.log("customerTypeCode", xdata?.customerTypeCode);

    const localPrice = ["CNT", "CNM", "CNS"];
    const agencyPrice = ["CNA", "CNC", "CNE", "CNF"];

    let typecode = "";

    if (localPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Local";
    } else if (agencyPrice.includes(xdata?.customerTypeCode)) {
      typecode = "Agency";
    }

    getDataTableCart(xdata, typecode);
  };
  useEffect(() => {
    console.log("id--", id);
    // const dateFormat = "DD-MM-YYYY";

    console.log(
      "month"
      // moment("2022/07/31").add(12, "months").format(dateFormat)
      // +"----  " +
      //   moment("2022/04/01").format(dateFormat)
    );

    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title={`${soHead}`} btnBack>
        {/* <MainButton title="ซื้อคอร์สเพิ่ม" to="/opd/so/buy" /> */}
      </HeaderBar>
      <div style={{ padding: "0px 40px" }}>
        <Form form={form} onFinish={onSubmit}>
          <div className="card-view-custom" style={{ padding: "20px" }}>
            <Row gutter={[16, 16]} className="custom-card">
              <Col span={6}>
                <p>ชื่อลูกค้า/Customer Name</p>
                <Form.Item name="customer">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>รหัสลูกค้า/CN</p>
                <Form.Item name="cn">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>สาขา/Branch </p>
                <Form.Item name="branch">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>วันที่/Date</p>
                <Form.Item name="date">
                  <DatePicker
                    inputReadOnly
                    format={dateFormat1}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "1px solid #d9d9d9",
                    }}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[16, 16]}
              className="custom-card"
              style={{ marginTop: "20px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 1/ Co - User No.1</p>
                <Form.Item name="Couser1">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 1/Co - User No.1"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser1(e, "couserat1");
                      // setCouserat2("");
                      setdisabledCouser({
                        CoUser2: false,
                        CoUser3: true,
                        CoUser4: true,
                      });
                      form.setFieldsValue({
                        Couser2: null,
                        Couser3: null,
                        Couser4: null,
                      });
                    }}
                    disabled={!isDisabled}
                  >
                    {couserat1}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 2/ Co - User No.2</p>

                <Form.Item name="Couser2">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 2/Co - User No.2"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser2(e, "couserat2");
                      setdisabledCouser({
                        CoUser3: false,
                        CoUser4: true,
                      });
                      form.setFieldsValue({
                        Couser3: null,
                        Couser4: null,
                      });
                    }}
                    disabled={disabledCouser.CoUser2}
                  >
                    {couserat2}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 3/ Co - User No.3</p>

                <Form.Item name="Couser3">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 3/Co - User No.3"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser3(e, "couserat3");
                      setdisabledCouser({
                        CoUser4: false,
                      });
                      form.setFieldsValue({
                        Couser4: null,
                      });
                    }}
                    disabled={disabledCouser.CoUser3}
                  >
                    {couserat3}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <p>ผู้ใช้ร่วมที่ 4/ Co - User No.4</p>

                <Form.Item name="Couser4">
                  <Select
                    style={{ width: "100%" }}
                    placeholder="เลือกผู้ใช้ร่วมที่ 4/Co - User No.4"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      onchangeUser4(e, "couserat4");
                    }}
                    disabled={disabledCouser.CoUser4}
                  >
                    {couserat4}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[16, 16]}
              className="custom-card"
              style={{ marginTop: "30px" }}
            >
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 1/Consult 1</p>
                <Form.Item
                  name="consult1"
                  rules={[
                    {
                      required: true,
                      message: "กรุณาเลือกข้อมูล!",
                    },
                  ]}
                >
                  {/* <Select
                    style={{ width: "100%" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      form.setFieldsValue({ consult2: null });
                      onchangeconsult(e);
                      // onChangeSelectconsult(e);
                    }}
                    disabled={true}
                  >
                    {consult}
                  </Select> */}
                  <Input disabled={true}></Input>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>ผู้ดูแล 2/Consult 2</p>
                <Form.Item name="consult2">
                  {/* <Select
                    style={{ width: "100%" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e) => {
                      onchangeconsult2(e);
                      // onChangeSelectconsult(e);
                    }}
                    disabled={true}
                  >
                    {consult2}
                  </Select> */}
                  <Input disabled={true}></Input>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6} style={{ marginTop: "10px" }}>
                <p>แพทย์/Doctor</p>
                <Form.Item name="doctor">
                  {/* <Select
                    style={{ width: "100%", marginTop: "4px" }}
                    placeholder="ไม่ระบุ/Not Specified"
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    onChange={(e: any) => {
                      console.log("e doctor", e);
                      if (e !== null) {
                        //   console.log("doc change ", checkDoctor);
                        //   infoDoctor(e);
                        // } else {
                        //   OnchangeDoc(e);
                        //   getDatas(other);
                        // setCheckDoctor({ ...checkDoctor, doctor: false });
                      }
                    }}
                    disabled={true}
                  >
                    {doctor}
                  </Select> */}
                  <Input disabled={true}></Input>
                </Form.Item>
              </Col>
              <Col span={6} style={{ alignSelf: "center", paddingTop: "25px" }}>
                {isDisabled === false ? (
                  <MainButton
                    onClick={() => {
                      setIsDisabled(true);
                      setdisabledCouser({
                        CoUser1: true,
                        CoUser2: true,
                        CoUser3: true,
                        CoUser4: true,
                      });
                    }}
                    background="#4D7E7F"
                    width="100%"
                    height="50px"
                    title="แก้ไขข้อมูล/Edit"
                  ></MainButton>
                ) : (
                  <Button
                    htmlType="submit"
                    style={{
                      width: "100%",
                      height: 50,
                      background: "#4D7E7F",
                      borderRadius: 4,
                      color: "white",
                    }}
                  >
                    บันทึกการแก้ไขข้อมูล/Submit
                  </Button>
                )}
              </Col>
            </Row>
          </div>

          <div style={{ marginTop: "40px" }} className="text-itle">
            <h4>รายการที่ซื้อ/Purchase Item</h4>
          </div>
          <div style={{ marginTop: "20px" }}>
            <div style={{ marginTop: "20px" }} className="table-data">
              <Table
                columns={typeSaleCheck === "normal" ? columns : columnspromo}
                dataSource={dataTable}
                bordered
                scroll={{ x: 1500 }}
              />
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default SoDetail;
